module.exports = __webpack_public_path__ + "img/kr-card-top-icon-white-1.5ae3d2b.png";